import { gql } from '@efficiently/client-core-graphql-models';

export const SAVE_FINISH_DEPENDENT_ITEMS = gql(`
	mutation FinishDomainSaveFinishDependentItems($records: [FinishToDependentItemInput!]!) {
		saveFinishDependentItems(records: $records) {
			_id
			finishId
			finishIdToDependentItemId
			netQuantity
			wastage
			grossQuantity
			createdDate
			createdById
		}
	}
`);
